(function ($) {
    'use strict';

    $(function () {
        const $tabs = $('.js-tabs');
        const activeClass = 'is-active';
        const hoverClass = 'is-hover';
        const mq = window.matchMedia('(hover: hover)');

        if (!$tabs.length) return;

        $tabs.each(function () {
            const $this = $(this);
            const $trigger = $this.find('.js-tabs-trigger');
            const $target = $this.find('.js-tabs-target');
            const $border = $this.find('.js-tabs-list-border');

            $trigger.on('click', function () {
                const $clickedTrigger = $(this);
                const targetId = $clickedTrigger.attr('aria-controls');
                const $targetItem = $this.find(`#${targetId}`);

                $trigger.removeClass(activeClass).attr('aria-expanded', 'false');
                $target.removeClass(activeClass);
                $clickedTrigger.addClass(activeClass).attr('aria-expanded', 'true');
                $targetItem.addClass(activeClass);
            });

            $trigger.on('mouseenter', function () {
                if (!mq.matches) return;

                const $hoveredTrigger = $(this);
                const offset = $hoveredTrigger.position().top;
                const height = $hoveredTrigger.outerHeight();

                $this.addClass(hoverClass);

                $border.css({
                    top: offset,
                    height: height
                });
            })

            $trigger.on('mouseleave', function () {
                if (!mq.matches) return;

                $this.removeClass(hoverClass);
            });
        });
    });
})(jQuery);